import React from 'react';
import LinkToGoogleMap from '../shared/LinkToGoogleMap';

type Props = {
  reportedByCarvaloo?: boolean;
  userReferralCode?: string;
  geoLocation?: string;
};

/**
 * Shared "by <reporter> | <location>" line used in the Reported section of
 * both ClaimInfo (Info tab) and ClaimStatus (Status tab).
 */
const ReportedByLine: React.FC<Props> = ({
  reportedByCarvaloo,
  userReferralCode,
  geoLocation,
}) => {
  const reporter = reportedByCarvaloo
    ? 'carvaloo'
    : userReferralCode || undefined;

  if (!reporter && !geoLocation) return null;

  return (
    <pre className="reservedAtBody">
      {reporter && `by ${reporter}${geoLocation ? '|' : ''}`}
      <LinkToGoogleMap position={geoLocation} />
    </pre>
  );
};

export default ReportedByLine;
